/**
  メイントップページ
*/
<template>
  <v-ons-page>
    <div class="content">
      <h2>{{title}}</h2>
      <div class="page_container">
        <div class="link_block" id="link1" @click="navigateOrderPage({menu:'order', code:'304', data:{mode:'back'}})">
           <ons-ripple></ons-ripple>
        </div>
        <div class="link_block" id="link2" @click="navigateOrderPage({menu:'order', code:'304', data:{mode:'back'}})">
           <ons-ripple></ons-ripple>
        </div>
        <div class="link_block" id="link3" @click="navigateOrderPage({menu:'order', code:'304', data:{mode:'back'}})">
           <ons-ripple></ons-ripple>
        </div>
        <div class="link_block" id="link4" @click="navigateOrderPage({menu:'order', code:'304', data:{mode:'back'}})">
           <ons-ripple></ons-ripple>
        </div>

        <div class="link_block" id="link5" @click="navigateOrderPage({menu:'order', code:'304', data:{mode:'back'}})">
           <ons-ripple></ons-ripple>
        </div>
        <div class="link_block" id="link6" @click="navigateOrderPage({menu:'order', code:'304', data:{mode:'back'}})">
           <ons-ripple></ons-ripple>
        </div>
        <div class="link_block" id="link7" @click="navigateOrderPage({menu:'order', code:'304', data:{mode:'back'}})">
           <ons-ripple></ons-ripple>
        </div>
        <div class="link_block" id="link8" @click="navigateOrderPage({menu:'order', code:'304', data:{mode:'back'}})">
           <ons-ripple></ons-ripple>
        </div>
        <img class="bg_img" src="../assets/img/menu.png" alt="">
      </div>
    </div>
  </v-ons-page>
</template>

<script>
//import WaitingIcon from "../components/WaitingIcon";
import { mapGetters, mapActions } from "vuex";
//import moment from "moment";
//import "moment/locale/ja";

export default {
  name: "home",
  props:{
    title: { type: String, default: '' },
  },
  data() {
    return {
      segmentIndex: 0,
      segment2Index: 1,
      tabbarIndex: 0,
      tabs: [
        {
          page: tabPage,
          props: {
            title: 'Page1',
            logIndexes: this.logIndexes
          },
          key: "tabPage1"
        },
        {
          page: tabPage,
          props: {
            title: 'Page2',
            logIndexes: this.logIndexes
          },
          key: "tabPage2"
        },
        {
          page: tabPage,
          props: {
            title: 'Page3',
            logIndexes: this.logIndexes
          },
          key: "tabPage3"
        }
      ]
    };
  },
  created: function() {
  },
  computed: {
    ...mapGetters([
      ]),
  },
  methods: {
    ...mapActions([
      "navigatePage",
      "navigateOrderPage",
    ]),
   
  },
  components: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss" scoped>
@import "../assets/sass/base.scss";

#link1{
  top: calc(100vw*25/750*2);
  left: calc(100vw*25/750*2);
  width: calc(100vw*150/750*2);
  height: calc(100vw*250/750*2);
}
#link2{
  top: calc(100vw*25/750*2);
  left: calc(100vw*200/750*2);
  width: calc(100vw*150/750*2);
  height: calc(100vw*250/750*2);
}

#link3{
  top: calc(100vw*280/750*2);
  left: calc(100vw*25/750*2);
  width: calc(100vw*150/750*2);
  height: calc(100vw*250/750*2);
}
#link4{
  top: calc(100vw*280/750*2);
  left: calc(100vw*200/750*2);
  width: calc(100vw*150/750*2);
  height: calc(100vw*250/750*2);
}

#link5{
  top: calc(100vw*560/750*2);
  left: calc(100vw*25/750*2);
  width: calc(100vw*150/750*2);
  height: calc(100vw*250/750*2);
}
#link6{
  top: calc(100vw*560/750*2);
  left: calc(100vw*200/750*2);
  width: calc(100vw*150/750*2);
  height: calc(100vw*250/750*2);
}

#link7{
  top: calc(100vw*835/750*2);
  left: calc(100vw*25/750*2);
  width: calc(100vw*150/750*2);
  height: calc(100vw*250/750*2);
}
#link8{
  top: calc(100vw*835/750*2);
  left: calc(100vw*200/750*2);
  width: calc(100vw*150/750*2);
  height: calc(100vw*250/750*2);
}


/****************************/
</style>



// WEBPACK FOOTER //
// src/pages/SingleMenuPage.vue